import { Injectable } from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import { ToastController } from '@ionic/angular';

// TEMP_COMMENT - import { Storage } from '@ionic/storage'; // IonicStorageModule


// third party libraries here
// https://forum.ionicframework.com/t/how-to-include-moment-js-in-ionic4/145819
import * as moment from 'moment'; 
import * as lodash from 'lodash';

// My services and providers
import { GlobalService } from '../global/global.service';
import { encode } from 'punycode';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private consoleLog:boolean = false;

  constructor( 
               public translate: TranslateService
             , private toastController: ToastController
             , private globalProvider: GlobalService
             // TEMP_COMMENT - , private storage: Storage
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_common;
    if (this.consoleLog) console.log('CommonProvider.ctor - LifeCycle');
  }

  // ------------------------------------------------------------
  // newly added functions since ambit 3
  // ------------------------------------------------------------

  DeepCopy(inputObject:any): any
  {
    // ref: https://stackoverflow.com/questions/36124363/deep-copying-objects-in-angular
    // ref: https://stackoverflow.com/questions/46329213/angular4-copy-object-without-reference
    // ref: http://blog.bogdancarpean.com/deepcopy-of-javascript-objects-and-arrays-using-lodashs-clonedeep-method/
    //if (this.consoleLog) console.log("DeepCopy before", inputObject);
    //var partial = JSON.stringify(inputObject);
    //if (this.consoleLog) console.log("DeepCopy partial", partial);

    //var outputObject = JSON.parse(JSON.stringify(inputObject));
    //if (this.consoleLog) console.log("DeepCopy after", outputObject);

    //var outputObject1 = Object.assign({}, inputObject);
    //if (this.consoleLog) console.log("DeepCopy after 1", outputObject1);

    let outputObject = lodash.cloneDeep(inputObject);
    //if (this.consoleLog) console.log("DeepCopy after", outputObject);

    return outputObject;
  }

  //Clone(Object)
  //{
  //      // use jQuerys extend method:
  //      return $.extend(true,{},Object);
  //}


  // ------------------------------------------------------------
  // code originally from ambit.js
  // ------------------------------------------------------------

  GetArrayValues(inValue:any, splitDelimiter:string, outDefault:any) // assumes delimiter is '|'
  {
    //console.log("GetValue:" + inValue);
    try
    {	
      //if (inValue === null)
      if ((typeof inValue === 'undefined')  || (inValue === null) || (inValue === "{}"))
      {
        //console.log("GetValue:" + inValue + " return default:" + outDefault);
        return outDefault;
      }

      // return inValue.split('|');
      return inValue.split(splitDelimiter);
    }
    catch (exception)
    {
      //alert("ambit.GetValue - Exception: " + exception + "  (outDefault: " + outDefault + ")");
      console.warn("GetValue:" + inValue + " exception", exception);
      return outDefault;
    }
  }
  GetValue(inValue:any, outDefault)
  {
    //console.log("GetValue:" + inValue);
    try
    {	
      //if (inValue === null)
      if ((typeof inValue === 'undefined')  || (inValue === null) || (inValue === "{}"))
      {
        //console.log("GetValue:" + inValue + " return default:" + outDefault);
        return outDefault;
      }
      return inValue;
    }
    catch (exception)
    {
      //alert("ambit.GetValue - Exception: " + exception + "  (outDefault: " + outDefault + ")");
      console.warn("GetValue:" + inValue + " exception", exception);
      return outDefault;
    }
  }
  GetBoolean(inValue:any, outDefault:boolean):boolean
  {
    try
    {
      if ((typeof inValue === 'undefined')  || (inValue === null) || (inValue === "{}"))
      {
        return outDefault;
      }

      // usually we expect "TRUE" to be the value, 
      // but adding other possibilities without doing all the string toUpper conversion
      let myBool = inValue === true || inValue === "TRUE" || inValue === "true" || inValue === "True";
      return myBool;
    }
    catch (exception)
    {
      //alert("ambit.GetValue - Exception: " + exception + "  (outDefault: " + outDefault + ")");
      return outDefault;
    }
  }
  //GetNumber(inValue:any, outDefault:number):number
  GetNumber(inValue:number, outDefault:number, label:string = ""):number
  {
    //console.log(label + " GetNumber:" + inValue);
    try
    {	
      let convertedValue = inValue * 1;
      //console.log(label + " GetNumber:" + inValue + " return converted:" + convertedValue + " ... *1");
      return convertedValue;

      /*
        2018-08-10:  Peter
          This code had been working for the past few years, but suddenly stopped working today
          I don't know why, but I suspect that using it with "typescript" has caused an issue
          Although it was working fine with Typescript for the past several weeks, I am wondering
          if the typing of the input/outpuot fields has caused a change whereby a string input
          can no longer be converted to a number output via parseInt() nor via Number()
          The only fix I could come up woth was to change the input type from "any" to "number"
      */

      /*
      if ((typeof inValue === 'undefined') || (inValue = "") || (inValue === null) || (inValue === "{}"))
      {
        console.log("GetNumber:" + inValue + " return default:" + outDefault);
        return outDefault;
      }
      */

      /*
      let baseDecimal = 10;
      //let convertedValue = parseInt(inValue, baseDecimal);
      let convertedValue:number = Number(inValue);
      
      console.log("GetNumber:" + inValue + " return converted:" + convertedValue);
      return convertedValue;
      */
    }
    catch (exception)
    {
      console.warn("GetNumber:" + inValue + " exception", exception);
      //alert("ambit.GetValue - Exception: " + exception + "  (outDefault: " + outDefault + ")");
      return outDefault;
    }
  }

  //GetNumber(inValue:any, outDefault:number):number
  GetNumberFromString(inValue:string, outDefault:number, label:string = ""):number
  {
    //console.log(label + " GetNumber:" + inValue);
    try
    {	
      /*
        2018-08-10:  Peter
          Use this when the input variable is a specifically defined TypeScript string
      */

      if ((typeof inValue === 'undefined') || (inValue = "") || (inValue === null) || (inValue === "{}"))
      {
        //console.log("GetNumberFromString:" + inValue + " return default:" + outDefault);
        return outDefault;
      }

      let baseDecimal = 10;
      let convertedValue = parseInt(inValue, baseDecimal);
      //let convertedValue:number = Number(inValue);
      
      //console.log("GetNumberFromString:" + inValue + " return converted:" + convertedValue);
      return convertedValue;
    }
    catch (exception)
    {
      console.warn("GetNumberFromString:" + inValue + " exception", exception);
      //alert("ambit.GetValue - Exception: " + exception + "  (outDefault: " + outDefault + ")");
      return outDefault;
    }
  }

  // ------------------------------------------------------------
  // code originally from myCommonCode.js
  // ------------------------------------------------------------

  /*
  GetStorageValue(key: string): Promise<any> 
  {
    return this.storage.get(key);
  }

  SetStorageString(key: string, value:string):string
  {
    try
    {
      this.storage.set(key, value);
      return value;
    }
    catch (err)
    {
      console.error("SetStorageValueString " + key + " - error:" + err);
      return value;
    }
  }

  SetStorageBoolean(key: string, value:boolean):boolean
  {
    try
    {
      this.storage.set(key, value);
      return value;
    }
    catch (err)
    {
      console.error("SetStorageValueBoolean " + key + " - error:" + err);
      return value;
    }
  }

  SetStorageNumber(key: string, value:number):number
  {
    try
    {
      this.storage.set(key, value);
      return value;
    }
    catch (err)
    {
      console.error("SetStorageValueNumber " + key + " - error:" + err);
      return value;
    }
  }
  */

  // --------------------------------------------------
  GetQsLiveEventsFilter(LiveFlag, isEncode:boolean)  // true ||  false ||  null
  {
      // console.log("CommonCode.GetQsLiveEventsFilter - liveEventsFilter:" + LiveFlag);

      let qsLiveFlag;
      if (LiveFlag === true)
      {
        if (isEncode) { qsLiveFlag = "&Filter=" + encodeURIComponent("LiveFlag|EQ|1"); }
        else          { qsLiveFlag = "&Filter=LiveFlag|EQ|1"; }
      }
      else if (LiveFlag === false)
      {
        if (isEncode) { qsLiveFlag = "&Filter=" + encodeURIComponent("LiveFlag|EQ|0"); }
        else          { qsLiveFlag = "&Filter=LiveFlag|EQ|0"; }
      }
      else
      {
        qsLiveFlag = "";
      }


      // console.log("CommonCode.GetQsLiveEventsFilter - qsLiveFlag:" + qsLiveFlag);
      return qsLiveFlag;
  }

  // --------------------------------------------------
  GetQsBooleanFilter(LiveFlag, isEncode:boolean, keyName:string)  // true ||  false ||  null
  {
      // console.log("CommonCode.GetQsLiveEventsFilter - liveEventsFilter:" + LiveFlag);

      let qsLiveFlag;
      if (LiveFlag === true)
      {
        if (isEncode) { qsLiveFlag = "&Filter=" + encodeURIComponent(keyName + "|EQ|1"); }
        else          { qsLiveFlag = "&Filter=" + keyName + "EQ|1"; }
      }
      else if (LiveFlag === false)
      {
        if (isEncode) { qsLiveFlag = "&Filter=" + encodeURIComponent(keyName + "|EQ|0"); }
        else          { qsLiveFlag = "&Filter=" + keyName + "|EQ|0"; }
      }
      else
      {
        qsLiveFlag = "";
      }


      // console.log("CommonCode.GetQsLiveEventsFilter - qsLiveFlag:" + qsLiveFlag);
      return qsLiveFlag;
  }


  // --------------------------------------------------
  isLanguageRtl(LanguageId:number):boolean
  {
    // ToDo:  this value should really be returned by the API server when setting the language
    // ToDo:  this value should really be returned by the API server when setting the language
    // ToDo:  this value should really be returned by the API server when setting the language
    if (   (LanguageId === 2)  // arabic
        || (LanguageId === 5)  // urdu
       )
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  // --------------------------------------------------
  endsWith(str:string, suffix:string):boolean
  {
    // ref: http://stackoverflow.com/questions/280634/endswith-in-javascript
    // note:  the str.endsWith function provided by Javascript fails on older Android browsers
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  }

  GenerateNewUploadFileName(PathFileOriginalName:string, ContextId:number):string
  {
      let filename = PathFileOriginalName.split('\\').pop().split('/').pop();
      let extension = filename.substr(( Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1);

      if (!extension)
      {
        extension = "jpg";
      }

      let  NewUploadFileName = "ambitUpload_" 
                             + moment().format('YYYYMMDD-HHmmss') 
                             + "_"
                             + ContextId
                             + "." + extension;
      return NewUploadFileName;
  }

  myTranslate(value:string):string
  {
    // WARNING! inline translation will CRASH if the value is empty
    if (!value) { return ""; }
    return this.translate.instant(value);
  }

  async presentToast(toastMessage:string, technicalAppend:string = "") 
  {
    // https://ionicframework.com/docs/api/toast-controller
    console.log("Common.presentToast: " + toastMessage + " ... " + technicalAppend);

    const toast = await this.toastController.create(
      { message: this.myTranslate(toastMessage) + " " + this.wrapInParenthesis(technicalAppend)
      , duration: 1000
      //, position: 'middle'
      //, cssClass: 'cssClassToast'  // see app.scss
    });
    toast.present();
  }

  async presentToastError(toastMessage:string, technicalAppend:string = "") 
  {
    console.log("Common.presentToastError: " + toastMessage + " ... " + technicalAppend);

    /*  ToastController has changed in Ionic 5 (of course, why would anything be stable)
    const toast1 = await this.toastController.create(
      { message: this.myTranslate(toastMessage) + " " + this.wrapInParenthesis(technicalAppend)
      //, duration: 1500
      , showCloseButton: true   // <<<<<< no longer supported
      , closeButtonText: this.myTranslate("OK")
      , position: 'middle'
      //, cssClass: 'cssClassToastError'  // see app.scss
    });
    toast1.present();
    */ 

    const toast = await this.toastController.create(
      { header: this.myTranslate(toastMessage)
      , message: technicalAppend
      , position: 'middle'
      , buttons: [
        { text: this.myTranslate("OK")
        , role: 'cancel'
        , handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    toast.present();
  }

  async presentToastErrorCatch(toastMessage:string, err:any) 
  {
    console.log("Common.presentToastErrorCatch: " + toastMessage, err);

    let technicalAppend = "";
    if (err)
    {
      if ((err.name) && (err.message))
      {
        technicalAppend = err.name + ": " + err.message;
      }
      else if (err.message)
      {
        technicalAppend = "Caught exception" + ": " + err.message;
      }
      else 
      {
        technicalAppend = "Caught exception" + ": " + "Unknown cause (1)";
      }
    }
    else
    {
      technicalAppend = "Caught exception" + ": " + "Unknown cause";
    }

    /*  ToastController has changed in Ionic 5 (of course, why would anything be stable)
    const toast = await this.toastController.create(
      { message: this.myTranslate(toastMessage) + " " + this.wrapInParenthesis(technicalAppend)
      //, duration: 1500
      , showCloseButton: true
      , closeButtonText: this.myTranslate("OK")
      , position: 'middle'
      //, cssClass: 'cssClassToastError'  // see app.scss
    });
    toast.present();
    */ 

    const toast = await this.toastController.create(
      { header: this.myTranslate(toastMessage)
      , message: technicalAppend
      , position: 'middle'
      , buttons: [
        { text: this.myTranslate("OK")
        , role: 'cancel'
        , handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    toast.present();
  }

  async presentToastStick(toastMessage:string, technicalAppend:string = "") 
  {
    console.log("Common.presentToastStick: " + toastMessage + " ... " + technicalAppend);

    /*  ToastController has changed in Ionic 5 (of course, why would anything be stable)
    const toast = await this.toastController.create(
      { message: this.myTranslate(toastMessage) + " " + this.wrapInParenthesis(technicalAppend)
      //, duration: 1500
      , showCloseButton: true
      , closeButtonText: this.myTranslate("OK")
      , position: 'middle'
      //, cssClass: 'cssClassToastError'  // see app.scss
    });
    toast.present();
    */ 

    const toast = await this.toastController.create(
      { header: this.myTranslate(toastMessage)
      , message: technicalAppend
      , position: 'middle'
      , buttons: [
        { text: this.myTranslate("OK")
        , role: 'cancel'
        , handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    toast.present();
  }

  GetHttpErrorReason(functionName, reason)
  {
      //var functionName = $localStorage.HttpInfo || "";  // see root.AmbitApiUrl below
      let returnErrorReason = "";
      
      try
      {
          if (reason)
          {
              let reasonString = JSON.stringify(reason);
              console.log(functionName + ": " + reasonString);
              //alert(functionName + ": " + reasonString);
              returnErrorReason = reason.status + "-" + reason.statusText;
          }
          else
          {
              returnErrorReason = "Unknown http error";
          }

          //$localStorage.HttpInfo = functionName + ":" + returnErrorReason;
      }
      catch (error)
      {
          returnErrorReason = "Unable to evaluate http error";   
          //$localStorage.HttpInfo = functionName + ":" + returnErrorReason;
      }

      console.log(functionName + ":" + returnErrorReason);
      //alert(functionName + ":" + returnErrorReason);
      return returnErrorReason;
  }

  wrapInParenthesis(value:any):string
  {
    if (!value)
    {
      return "";
    }
    return "(" + value + ")";
  }

  GetSiteDistanceValue(SiteDistanceMiles, includeParenthesis, MetricUnitsFlag)
  {
    //var MetricUnitsFlag = this.globalProvider.UserAppConfig.MetricUnitsFlag;

    let inValue = SiteDistanceMiles;
    let inUnitType = "miles";
    let outUnitType = MetricUnitsFlag === true ? "km" : "miles" ;
    let outUnitTypeDisplay = this.myTranslate(outUnitType);  // i.e. translate the word "miles" or "km"
    
    return this.GetDistanceDisplayValue( inValue, inUnitType
                                        , outUnitType, outUnitTypeDisplay
                                        , true    // includeUnitType
                                        , includeParenthesis
                                        ); 
  }

  GetDistanceDisplayValue( inValue, inUnitType
    , outUnitType, outUnitTypeDisplayName
    , includeUnitType, includeParenthesis )
  {
    if (!inValue)
    {
      return "";
    }

    try
    {
      let outValue;

      // -------------------- CONVERT ---------------------------------

      if (inUnitType === "miles")
      {
        if      (outUnitType === "miles") { outValue = inValue; }
        else if (outUnitType === "km")    { outValue = inValue * 1.6; }
      }
      else if (inUnitType === "km")
      {
        if      (outUnitType === "km")    { outValue = inValue; }
        else if (outUnitType === "miles") { outValue = inValue * 0.6; }
      }

      // -------------------- DISPLAY VALUE ----------------------------------

      if (outValue)
      {
        if (outValue > 99.99)
        {
          // round up with no decimal places
          outValue = Math.round(outValue);  // turn 35.67 into 36 (drop the decimals)
        }
        else
        {
          // round up, with two decimal places
          outValue = Math.round(outValue * 100) / 100;  
          // there are edge cases which we can ignore 
          // ref: https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
        }
      }
      
      // -------------------- DISPLAY UNIT ----------------------------------

      if (includeUnitType)
      {
        outValue = outValue + " " + outUnitTypeDisplayName; // $translate.instant(outUnitType);
      }

      // -------------------- DISPLAY UNIT ----------------------------------

      if (includeParenthesis)
      {
        outValue = "(" + outValue + ")";
      }

      return outValue;
    }
    catch (err)
    {
      console.error("GetDistanceDisplayValue error: " + err);
    }
  }


  GetApiReturnMessage(ApiReturn):string
  {
    console.log("common.GetApiReturnMessage");

    try
    {
      if (!(ApiReturn))
      {
        console.log("common.GetApiReturnMessage: ApiReturn is not defined");
        return "(Null ApiReturn)";
      }
  
      let ApiReturnCode = ApiReturn.ApiReturnCode || "Log";
      let MobileDisplayText = ApiReturn.MobileDisplayText || "";
      let ApiReturnText = ApiReturn.ApiReturnText || "";
  
      let DisplayMessage;
  
      // In reality there should ALWAYS be a MobileDisplayText, but at a minimum an ApiReturnText
      // Sometimes the development on the API service side needs to catch up with all error possibilities
      if (MobileDisplayText !== "")
      {
          DisplayMessage = MobileDisplayText;
      }
      else if (ApiReturnText !== "")
      {
          DisplayMessage = ApiReturnText;
      }
      else
      {
          DisplayMessage = "";
      }
  
      let returnMessage = DisplayMessage
                + " ("
                //+ ApiReturnCode + "-" 
                + ApiReturn.ApiLogId
                //+ ApiReturnText		// ToDo:  remove the text later
                + ") ";
  
      console.log("common.GetApiReturnMessage: " + returnMessage);
      return returnMessage;
    }
    catch(err)
    {
      console.log("GetApiReturnMessage: unable to retrieve error message");
      return "(Error ApiReturn)";
    }
  }

  GetWindowLocationHost():string
  {
    let url;
    /*
    var window: any;
    console.log("GetWindowLocationHost - window", window);
    
    url = window.location.host; // window.location.hostname;
    console.log("GetWindowLocationHost - window", window);
    */ 

    url = document.URL;

    return url;
  }

  /*
  SwitchToCorsForLocal(context):boolean
  {
    try
    {
      var url:any = this.GetWindowLocationHost(); // window.location.hostname;
      var clientDomainName = url.replace('http://','').replace('https://','').split(/[/?#]/)[0];
      
      //console.log("CommonCode.SwitchToCorsForLocal - clientDomainName:" + clientDomainName);
      var TestWithCorsFlag:boolean = false;
      if (   (clientDomainName === "localhost") 
          || (clientDomainName === "127.0.0.1") 
          || (clientDomainName === "0.0.0.0")
         )
      {
        TestWithCorsFlag = true;
      }
      this.storage.set("TestWithCorsFlag", TestWithCorsFlag);

      console.log("CommonCode.SwitchToCorsForLocal:" + TestWithCorsFlag
                + " for " + clientDomainName + " via " + context);

      return TestWithCorsFlag;
    }
    catch (error)
    {
      console.log("CommonCode.SwitchToCorsForLocal - exception... ");
      alert("SwitchToCorsForLocal error (" + context + "): " + error);
      return false;
    }
  }
  */
}

